/* esm.sh - rxjs@7.8.1/dist/esm/internal/operators/concatMap */
import{mergeMap as i}from"./mergeMap.mjs";import{isFunction as m}from"../util/isFunction.mjs";function t(n,o){return m(o)?i(n,o,1):i(n,1)}export{t as concatMap};
//# sourceMappingURL=concatMap.mjs.map